export default class UnauthorizedError extends Error {
}
